import React from 'react';
import { Box, Card, CardContent, Skeleton, Typography } from '@mui/material';

export default function TourCardPublicSkeleton() {
    return (
        <Card
            sx={{
                position: 'relative',
                height: 320,
                color: 'white',
                textDecoration: 'none',
                display: 'flex',
                flexDirection: 'column',
                overflow: 'hidden',
                borderRadius: 2,
            }}
            elevation={3}
        >
            {/* Background Skeleton Image */}
            <Box
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    overflow: 'hidden',
                    zIndex: 0,
                }}
            >
                <Skeleton
                    variant="rectangular"
                    width="100%"
                    height="100%"
                    sx={{
                        height: '100%',
                        objectFit: 'cover',
                    }}
                />
            </Box>

            {/* Content Skeleton */}
            <CardContent
                sx={{
                    position: 'relative',
                    zIndex: 2,
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                    height: '100%',
                    width: '100%',
                    p: 2,
                }}
            >
                <Box>
                    <Skeleton variant="text" width="60%" height={32} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="40%" height={20} sx={{ mb: 1 }} />
                    <Skeleton variant="text" width="30%" height={18} />
                </Box>

                <Box>
                    <Skeleton variant="text" width="100%" height={18} />
                    <Skeleton variant="text" width="80%" height={18} sx={{ mt: 0.5 }} />
                </Box>
            </CardContent>
        </Card>
    );
};
